import NextHead from "next/head";
import { withTranslation } from "next-i18next";
import { useRouter } from "next/router";

const Head = ({
  t, i18n,
}) => {
  const router = useRouter();
  const page = router.pathname.split("/").filter((pathPart) => !!pathPart).join(".");

  const title = (page && i18n.exists(`common:meta.${page}.title`)) ? t(`common:meta.${page}.title`) : t("common:meta.title");
  const description = (page && i18n.exists(`common:meta.${page}.description`)) ? t(`common:meta.${page}.description`) : t("common:meta.description");

  return (
    <NextHead>
      <title key="title">{title}</title>
      <meta name="description" key="description" content={description} />
    </NextHead>
  );
};

export default withTranslation("common")(Head);
